import { Controller } from 'react-hook-form';

import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Conversion } from '@/components/pages/edit-campaign/form-elements/conversion';
import { Cpa } from '@/components/pages/edit-campaign/form-elements/cpa';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';
import { useBudgetType } from '@/hooks/use-budget-type';

export function JoveoForm() {
  const { hookForm, campaign, isCompleted } = useEditCampaignContext();
  const isReadonly = campaign?.is_readonly;
  const { control, trigger } = hookForm;
  const { budgetTypeOptions } = useBudgetType();

  return (
    <>
      <Dates />

      <div className="flex flex-col gap-2">
        <Budget />
        <Controller
          control={control}
          name="budget_type"
          render={({ field }) => (
            <RadioGroup
              onValueChange={value => {
                field.onChange(value);
                void trigger('budget');
              }}
              value={field.value}
              className="my-2 flex justify-between gap-4"
              disabled={isCompleted || isReadonly}
            >
              {budgetTypeOptions.map(option => (
                <div
                  key={option.value}
                  className="flex items-center space-x-2 whitespace-nowrap"
                >
                  <RadioGroupItem value={option.value} id={option.value} />
                  <Label htmlFor={option.value}>{option.label}</Label>
                </div>
              ))}
            </RadioGroup>
          )}
        />
      </div>

      <TargetBudget />
      <Cpa />
      <Conversion />
    </>
  );
}
